import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const SummaryContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div((props) => ({
  display: 'flex',
  marginTop: `${props.sub ? '0' : '1rem'}`,
  flexDirection: 'column',

  '&>div:first-child': {
    marginLeft: 0,
    marginTop: '0px',
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '0px',
    marginTop: '1rem',
    flex: 1
  },

  '.emptyCell': {
    display: 'none',
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },

    '.emptyCell': {
      display: 'block',
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },

    '.emptyCell': {
      display: 'block',
    },
  },

}))